import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import RouteTracker from './components/RouteTracker'

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <RouteTracker />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App